export const RESOURCES_LINK = 'https://pland.co/resources/';

export const CONTACTS_LINK = 'mailto:contact@pland.co';

export const FAQ_LINK = 'https://pland.co/faqs-helpcenter/';
